import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import * as pages from '../../../constants/data/pages';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import IntroTitlePage from './IntroTitlePage';
import IntroMessagePage from './IntroMessagePage';
import LooseDiamondPage from './LooseDiamondPage';
import ContactPage from './ContactPage';
import {ProductPageContainer} from './ProductPage';

class Page extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let startingPage = this.props.common.lastPageVisited ? this.props.common.lastPageVisited : 0;

    this.singlePageBreak = 768;

    this.state = {
      currentPage: startingPage,
      currentPageOffset: 0,
      pages: this.getPages(),
      whitePage: false,
    };
	}

  componentDidMount() {
    this.sliderObject.slickGoTo(this.state.currentPage);
  }

  componentDidUpdate(prevProps, prevState) {
    // if(this.props.common.lastPageVisited !== null && this.props.common.lastPageVisited != this.state.currentPage) {
    //   this.setState({
    //     currentPage: this.props.common.lastPageVisited,
    //     currentPageOffset: 0,
    //   });
    // }
  }

  leftNav(newKey, prevKey) {

    console.log(newKey);
    console.log(prevKey);

    // let newPage = this.state.currentPage;
    let newPage = newKey;
    let newPageOffset = this.state.currentPageOffset;

    if(window.innerWidth <= this.singlePageBreak) {
      // newPageOffset--;
      if(newPageOffset < 0) {
        newPageOffset = 1;
        // newPage -= 2;
      }
    } else {
      // newPage -= 2;
      newPageOffset = 0;
    }

    if(newPage < 0) {
      newPage = 0;
    }

    this.setState({
      currentPage: newPage,
      currentPageOffset: newPageOffset,
      whitePage: false,
    }, () => {
      this.props.commonSetLastVisited(this.getEffectivePage());
    });
  }

  rightNav(newKey, prevKey) {

    console.log(newKey);
    console.log(prevKey);

    // let newPage = this.state.currentPage;
    let newPage = newKey;
    let newPageOffset = this.state.currentPageOffset;

    if(window.innerWidth <= this.singlePageBreak) {
      // newPageOffset++;
      if(newPageOffset > 1) {
        newPageOffset = 0;
        // newPage += 2;
      }
    } else {
      // newPage += 2;
      newPageOffset = 0;
    }

    if(newPage > this.getPages().length - 2 || (window.innerWidth <= this.singlePageBreak && newPage > this.getPages().length - 1)) {
      this.context.router.push('/thankyou');
    } else {

      this.setState({
        currentPage: newPage,
        currentPageOffset: newPageOffset,
        whitePage: false, 
      }, () => {
        this.props.commonSetLastVisited(this.getEffectivePage());
      });
    }
  }

  getEffectivePage() {
    if(window.innerWidth <= this.singlePageBreak) {
      // return this.state.currentPage + this.state.currentPageOffset;
      return this.state.currentPage;
    } else {
      return this.state.currentPage;
    }
  }

  renderInternalElement(page) {
    if(page.component == 'ProductPage') {
      return <ProductPageContainer setWhiteBg={::this.setWhiteBg} gbWhite={false} product={page.product} />;
    } else if(page.component == 'IntroTitlePage') {
      return <IntroTitlePage setWhiteBg={::this.setWhiteBg} gbWhite={false} />;
    } else if(page.component == 'IntroMessagePage') {
      return <IntroMessagePage setWhiteBg={::this.setWhiteBg} gbWhite={false} />;
    } else if(page.component == 'LooseDiamondPage') {
      return <LooseDiamondPage setWhiteBg={::this.setWhiteBg} gbWhite={false} />;
    } else if(page.component == 'ContactPage') {
      return <ContactPage setWhiteBg={::this.setWhiteBg} gbWhite={true} />;
    } else if(page.component == 'LastPage') {
      return <ProductPageContainer product={page.product} showNoCopy={true} setWhiteBg={::this.setWhiteBg} gbWhite={false} />;
    }
  }

  setWhiteBg(bgValue) {
    // this.setState({ whitePage: bgValue });
  }

  nextSlide() {
    this.sliderObject.slickNext();
  }

  prevSlide() {
    this.sliderObject.slickPrev();
  }

  renderPage(page, index) {
    let wrapperClass = 'notVisible';
    if(this.getEffectivePage() === index) {
      wrapperClass = 'leftPage';
    } else if(this.getEffectivePage() + 1 === index) {
      wrapperClass = 'rightPage';
    }

    return (
      <div key={index} className={'pageContentWrapper ' + wrapperClass}>
        {this.renderInternalElement(page)}
      </div>
    );
  }

  getPages() {
    if(window.innerWidth <= this.singlePageBreak) {
      return pages.mobilePages;
    } else {
      return pages.pages;
    }
  }

  getPageStyle() {
    const styleObj = {};
    try {
      const page = this.getPages()[this.getEffectivePage()];

      if(page.bgColor) {
        styleObj['background'] = page.bgColor;
      }
    } catch(err) {
      console.error(err);
    }
    return styleObj;
  }

  renderCopy() { 
    
    try {
      const page = this.getPages()[this.getEffectivePage()];
      if(!page) {
        return null;
      }

      if(page.product.copy.length === 1) {
        return this.renderSingle(page.product, page.bgColor ? true : false);
      }

      if(page.product.copy.length == 2) {
        return this.renderDouble(page.product, page.bgColor ? true : false);
      }

      if(page.product.copy.length == 3) {
        return this.renderTriple(page.product, page.bgColor ? true : false);
      }
    } catch(err) {
      console.error(err);
    }
    return null;
  }

  renderSingle(productObj, darkBg = false) { 
    return <div className={`copyWrapper ${darkBg ? 'darkBg' : ''}`}>
      <div className='productNumber'>{productObj.pages[0]}</div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='singleCopy'>{productObj.copy[0]}</div>
    </div>;
  }

  renderDouble(productObj, darkBg = false) { 
    return <div className={`copyWrapper copyMultiple ${darkBg ? 'darkBg' : ''}`}>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[0]}</div>
        <div className='copyBody'>{productObj.copy[0]}</div>
      </div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[1]}</div>
        <div className='copyBody'>{productObj.copy[1]}</div>
      </div>
    </div>;
  }

  renderTriple(productObj, darkBg = false) { 
    return <div className={`copyWrapper copyMultiple copyTriple ${darkBg ? 'darkBg' : ''}`}>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[0]}</div>
        <div className='copyBody'>{productObj.copy[0]}</div>
      </div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[1]}</div>
        <div className='copyBody'>{productObj.copy[1]}</div>
      </div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[2]}</div>
        <div className='copyBody'>{productObj.copy[2]}</div>
      </div>
    </div>;
  }

  slideAction(oldKey, newKey) {
    if(newKey > oldKey) {
      this.rightNav(newKey, oldKey);
    } else if(newKey < oldKey) {
      this.leftNav(newKey, oldKey);
    }
  }

	render() {

    let settings = {
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,
      speed: 500,
      cssEase: "linear",
      arrows: false,
      adaptiveHeight: true,
      beforeChange: this.slideAction.bind(this),
    };

    let doublePage = window.innerWidth <= this.singlePageBreak;

    if(doublePage) {
      settings = {
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 500,
        cssEase: "linear",
        arrows: false,
        adaptiveHeight: true,
        beforeChange: this.slideAction.bind(this),
      };
    }

		return <div className={this.state.whitePage ? 'Page whiteBg' : 'Page'} style={this.getPageStyle()}>
      <Slider ref={(slider) => { this.sliderObject = slider; }} {...settings}>
        {this.getPages().map((page, index) => {
          return this.renderPage(page, index);
        })}
      </Slider>
      <div className='imageCaption'>
        {this.renderCopy()}
      </div>
      {this.getEffectivePage() ? 
        <div className='leftNav' onClick={::this.prevSlide}>
          <img src='/img/svg/left.svg' />
        </div> :
        null
      }
      <div className='rightNav' onClick={::this.nextSlide}>
        <img src='/img/svg/right.svg' />
      </div>
		</div>;
	}
}
export default Page;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const PageContainer = connect(
  mapStateToProps,
  allActionCreators
)(Page);


// WEBPACK FOOTER //
// ./src/components/views/page/Page.jsx